import { render, staticRenderFns } from "./SelectedCustomer.vue?vue&type=template&id=283d59fa&scoped=true"
import script from "./SelectedCustomer.vue?vue&type=script&lang=js"
export * from "./SelectedCustomer.vue?vue&type=script&lang=js"
import style0 from "./SelectedCustomer.vue?vue&type=style&index=0&id=283d59fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d59fa",
  null
  
)

export default component.exports